import api from 'api';

const url = 'api/events/:id';

export default {
    fetch: (id, params) => api.get({path: url.replace(':id', +id), params})
}
